var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInTransport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7211 7.36689C19.7211 9.4335 16.3698 12.8127 16.3698 12.8127C16.3698 12.8127 13.0186 9.43517 13.0186 7.36689C13.0186 6.47808 13.3716 5.62565 14.0001 4.99717C14.6286 4.36868 15.481 4.01562 16.3698 4.01562C17.2586 4.01562 18.1111 4.36868 18.7395 4.99717C19.368 5.62565 19.7211 6.47808 19.7211 7.36689Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.98438C16.9102 7.98426 17.2432 7.65146 17.2432 7.24121C17.243 6.83106 16.9101 6.49816 16.5 6.49805C16.0898 6.49805 15.757 6.83099 15.7568 7.24121C15.7568 7.65153 16.0897 7.98438 16.5 7.98438Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H8.08579C8.03643 6 7.99446 6.03601 7.98695 6.08479L6.01772 18.8848C6.0084 18.9454 6.05527 19 6.11656 19H16.8867C16.9469 19 16.9934 18.9473 16.9859 18.8876L16.5 15",
    stroke: "#1A1A1A",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17V11",
    stroke: "#1A1A1A",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeDasharray: "2.4 2.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransport);
export default __webpack_public_path__ + "static/media/in_transport.c77e53af1f4228edbf0f6a153e448aa9.svg";
export { ForwardRef as ReactComponent };